import { Paragraph, SizableText, SmartLink, XStack, YStack, shadowStandard } from '@my/ui'
import { SaveOfferButton } from 'app/features/offer/containers'
import { SolitoImage } from 'solito/image'
import { BrandOfferCollectionBlock } from './brand-offer-collection.block'

export interface BrandOfferCollectionItemProps {
  offer: BrandOfferCollectionBlock['offers'][0]
}

export const BrandOfferCollectionItem = ({ offer }: BrandOfferCollectionItemProps) => {
  const imageUri = offer?.thumbnailImage?.url || offer?.featuredImage?.url

  return (
    <YStack bg="$white" position="relative" br="$3" flex={1} {...shadowStandard}>
      <XStack zIndex="$1" position="absolute" top="$2.5" right="$2.5">
        <SaveOfferButton size={30} offerId={offer.id} isBookmarked={offer.isBookmarked} />
      </XStack>

      <SmartLink
        Component={YStack}
        href={`/discounts/${offer.brand.slug}/${offer.slug}`}
        borderRadius="$3"
        bg="$white"
        width="100%"
        flex={1}
        hoverStyle={{
          opacity: 0.9,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
      >
        <YStack
          aspectRatio={9 / 5}
          $gtXs={{ aspectRatio: 11 / 7 }}
          width="100%"
          btlr="$3"
          btrr="$3"
          overflow="hidden"
        >
          <SolitoImage
            src={imageUri}
            alt={offer.featuredImage?.alt}
            contentFit="cover"
            fill
            sizes="(max-width: 900px) 50vw, 440px"
          />
        </YStack>

        <YStack gap="$2" $gtSm={{ gap: '$3.5' }}>
          <YStack
            aspectRatio={1}
            mx="auto"
            mt="$-6"
            borderRadius="$3"
            bc="$white"
            boc="$white"
            bw="$2"
            w={60}
            h={60}
            {...shadowStandard}
          >
            <SolitoImage
              src={offer.brand.logo.url}
              alt={offer.brand.logo.alt || offer.brand.name}
              contentFit="contain"
              style={{ borderRadius: 8, backgroundColor: 'white' }}
              sizes="60px"
              fill
            />
          </YStack>

          <YStack alignItems="center" flex={1} pb="$3.5" px="$3" $gtSm={{ pb: '$6', px: '$6' }}>
            <SizableText
              numberOfLines={2}
              textAlign="center"
              size="$3"
              fow="800"
              $gtSm={{ size: '$6', fow: '800' }}
            >
              {offer?.name}
            </SizableText>
            <Paragraph
              numberOfLines={2}
              textAlign="center"
              size="$2"
              color="$overlay11"
              pt="$1.5"
              $gtSm={{ size: '$4' }}
            >
              {offer?.description}
            </Paragraph>
          </YStack>
        </YStack>
      </SmartLink>
    </YStack>
  )
}
